import {
    GET_EldSub,
    GET_EldAllSub,
    ADD_EldSub,
    TOGGLE_EldSub,
    RESET_EldSub,
    UPDATE_EldSub
  } from "../actionTypes";

const elderSubReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_EldSub:
      return action.payload;

    case GET_EldAllSub:
      return action.payload;

    case ADD_EldSub:
      return action.payload;

    case UPDATE_EldSub:
      return state.map(item =>
        item.id === action.payload.id ? action.payload : item
      );

    case TOGGLE_EldSub:
      return {
        ...state,
        users: state.users.map(item =>
          item.userId === action.payload.userId ? action.payload : item
        )
      };

    case RESET_EldSub:
      return null;

    default:
      return state;
  }
};

export default elderSubReducer;
